import {connect} from 'react-redux';
import EventInfos from '../event/EventInfos.jsx';
import HelpInfo from '../event/HelpInfo.jsx';
import BookingZone from './booking/BookingZone.jsx';
import Spinner from '../../components/spinner/Spinner.jsx';
import SaleNotPossibleInfo from '../event/SaleNotPossibleInfo.jsx';
import CustomInfoBox from '../event/CustomInfoBox.jsx';
import history from "../../lib/history";
import eventService from '../../lib/event-service';

// Styles
import './EventPageSeatingplan.scss';

interface EventPageSeatingplanProps {
    event: {
		uuid: string,
		startOfSale?: any,
		availableTickets?: any,
		lifecyclePhase?: any
		title: '',
		subtitle: '',
		mainImageSrc: '',
		begin: '',
		venueId: '',
		categories: [],
		description: any,
		eventNotes?: any
	},
	venue: {
		name: '',
		location: {
			city: '',
		},
	},
	bookingOffice: {
		activShipmentTypes: [],
		shipmentFees: [],
		shipmentTypeAvailabilityInHours: [],
		activPaymentTypes: [],
		paymentTypeAvailabilityInHours: [],
	},
	volatileTicketAvailability: any,
	selectedTicketsByPriceLevelUuid: string,
	isLoading?: boolean,
	shouldRenderImage: boolean,
	imageMetaData: any,
    openPartnerShopErrorPage: boolean,
}

function EventPageSeatingplan(props: EventPageSeatingplanProps) {
    if (props.openPartnerShopErrorPage) {
        // @ts-expect-error history string
        history.push('partnershop-error');
    }
	const anyShipmentPaymentPossible = eventService.isAnyShipmentAndPaymentPossible(props.event, props.bookingOffice);

	const saleIsPossible = eventService.isSalePossible(
		props.event, props.volatileTicketAvailability,
		props.selectedTicketsByPriceLevelUuid,
		anyShipmentPaymentPossible
	);

	return props.isLoading ?
		(
			<Spinner/>
		) :
		(
			<div className="event">
				<EventInfos
					shouldRenderImage={props.shouldRenderImage}
					imageMetaData={props.imageMetaData}
					title={props.event.title}
					subtitle={props.event.subtitle}
					date={props.event.begin}
					description={props.event.description}
					location={<span> {props.venue.name}, {props.venue.location.city}</span>}
				/>
				<CustomInfoBox textPoperty="additionalEventInfo"/>
				{
					!saleIsPossible
					&& <SaleNotPossibleInfo
						lifeCyclePhase={props.event.lifecyclePhase}
						categoriesAreAvailable={(props.event.categories && (props.event.categories.length > 0))}
						ticketsAreAvailable={(props.event.availableTickets > 0)}
						startOfSale={props.event.startOfSale}
						shipmentPaymentPossible={anyShipmentPaymentPossible}
					/>
				}
				{
					saleIsPossible
					&& <BookingZone categories={props.event.categories} eventUUID={props.event.uuid}
									eventNotes={props.event.eventNotes}/>
				}
				<HelpInfo/>
			</div>
		);
}

// ------------------------------
// Store Connection
// ------------------------------

const mapStateToProps = (state:any) => {
	const event = state.event.elements[state.event.selected] || {};
	const selectedTicketsByPriceLevelUuid = state.eventPage.amountOfTickets;
	const volatileTicketAvailability = state.eventPage.volatileTicketAvailability;
	const shouldRenderImage = (event.imagesMetadataIds && event.imagesMetadataIds.length > 0);
	const imageMetaData = shouldRenderImage ?
		state.file.elements[event.imagesMetadataIds[0]] : {};

	return {
		isLoading: state.event.isLoading,
		venue: state.venue.elements[event.venueId],
		event,
		imageMetaData,
		shouldRenderImage,
		bookingOffice: state.bookingOffice,
		customer: state.customer,
		selectedTicketsByPriceLevelUuid,
		volatileTicketAvailability,
        openPartnerShopErrorPage: state.sponsorCodes.partnerShopFailed || state.sponsorCodes.partnershopErrors.length > 0,
	};
};

const mapDispatchToProps = () => ({});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(EventPageSeatingplan);
